module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Db-Fc-Ga-Hb-Ia.d75227fa.png";